export const normalizeExamenesAcademiaUsuario = (examenes) => {
  let examenesAcademiaUsuarioNormalizer = examenes;

  if (examenes && Array.isArray(examenes) && examenes.length > 0) {
    examenesAcademiaUsuarioNormalizer = examenes.map((exam) => {
      const newExam = {
        ...exam,
        selected: false,
        id_examen: exam.lista[0].id_examen
      }
      return newExam
    })
  }

  return examenesAcademiaUsuarioNormalizer
}